// extracted by mini-css-extract-plugin
module.exports = {"content":"Articles_content__1OOi5","title":"Articles_title__2auwy","subtext":"Articles_subtext__3cwR0","sidebarArticle":"Articles_sidebarArticle__1NKIT"};